import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

export default function Attenzione() {
  return (
    <div className="rounded-md bg-yellow-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon
            className="h-5 w-5 text-yellow-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">Attenzione</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>
              La presente pagina è stata realizzata esclusivamente a titolo
              dimostrativo e non rappresenta in alcun modo un cantiere realmente
              in corso d'opera
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
